import { Image, ImageProps } from '@chakra-ui/react';

export const ExternalImage = ({ src, alt, ...rest }: ImageProps) => {
  return <Image src={src} alt={alt} {...rest} />;
};

export default ExternalImage;
